export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ASSETS = {
  logo: "https://customer-assets-0z36b82j.emergentagent.net/job_mama-recovery-2/artifacts/a693gyyq_inborn%20logo%20bwn%20backround.jpg",
  badge: "https://customer-assets-0z36b82j.emergentagent.net/job_mama-recovery-2/artifacts/0s146tgy_INNATE%20Logo.webp",
  portrait: "https://customer-assets-eiarnc6j.emergentagent.net/job_134b3b07-bdc2-4f4a-bd99-c12f6d023f68/artifacts/tplw5z6l_Cozy%20pic%20near%20window%20.png",
  community: "https://customer-assets-0z36b82j.emergentagent.net/job_mama-recovery-2/artifacts/arxi6rwk_Community%20Foundation%20INNATE.png",
  handsOnWomb: "https://customer-assets-0z36b82j.emergentagent.net/job_mama-recovery-2/artifacts/lqo3dilg_hands%20on%20womb.jpg",
  takeCare: "https://customer-assets-gfyr7b9c.emergentagent.net/job_2407700e-5bf1-4db7-84ad-7a0f7cbba83c/artifacts/b3h31ygf_Take%20Care%20of%20Mother%27s.%20.JPG",
  motherSon: "https://customer-assets-0z36b82j.emergentagent.net/job_mama-recovery-2/artifacts/p0tl2q7d_Postpartum%20Mother%20and%20Son.JPG",
  honorBath: "https://customer-assets-eiarnc6j.emergentagent.net/job_134b3b07-bdc2-4f4a-bd99-c12f6d023f68/artifacts/vcxn3z6w_Birth%20of%20Mom%20%26%20Child.png",
  nutrition: "https://customer-assets-0z36b82j.emergentagent.net/job_mama-recovery-2/artifacts/zbzxx8h7_Visual%20Postpartum%20%28nutrition%29_.png",
  henna: "https://customer-assets-0z36b82j.emergentagent.net/job_mama-recovery-2/artifacts/hfdv8ktp_IMG_0290.jpg",
  thrive: "https://customer-assets-0z36b82j.emergentagent.net/job_mama-recovery-2/artifacts/n7uy8o4o_Thrive%20not%20just%20survive.%20Postpartum%20Care.png",
  portrait2: "https://customer-assets-0z36b82j.emergentagent.net/job_mama-recovery-2/artifacts/rmk4ehgo_Athena%20Pro%28W%29.jpg",
  rebozoRitual: "https://customer-assets-eiarnc6j.emergentagent.net/job_134b3b07-bdc2-4f4a-bd99-c12f6d023f68/artifacts/3bww2q4j_Athena%20Rebozo%202.jpg",
  sacredBath: "https://customer-assets-eiarnc6j.emergentagent.net/job_134b3b07-bdc2-4f4a-bd99-c12f6d023f68/artifacts/pa95494a_Sacred%20Bath.png",
};

export const TIME_SLOTS = [
  "9:00 AM",
  "10:30 AM",
  "12:00 PM",
  "2:00 PM",
  "3:30 PM",
];

// The First Forty Days runs on a fixed weekly rhythm:
// Mon & Wed — 10 AM–2 PM or 12–4 PM. Fri — 10 AM–1 PM.
export const FORTY_DAYS_SLUG = "the-first-forty-days";
export const FORTY_DAYS_TIME_SLOTS = [
  "10:00 AM – 2:00 PM",
  "12:00 PM – 4:00 PM",
];
export const FORTY_DAYS_FRIDAY_TIME_SLOTS = ["10:00 AM – 1:00 PM"];

export const getFortyDaysTimeSlots = (date) => {
  if (!date) return FORTY_DAYS_TIME_SLOTS;
  return date.getDay() === 5 ? FORTY_DAYS_FRIDAY_TIME_SLOTS : FORTY_DAYS_TIME_SLOTS;
};

import { getISOWeek } from "date-fns";

// Mondays–Wednesdays, plus every other Saturday (even ISO weeks)
// Bank transfer / ACH is preferred; card also accepted (arranged directly with Athena).
// The First Forty Days offers payment plans.
export const PAYMENT_PLAN_SLUGS = new Set(["the-first-forty-days"]);

// Mondays–Wednesdays, plus every other Saturday (even ISO weeks)
export const isBookingDay = (date) => {
  const day = date.getDay();
  if (day >= 1 && day <= 3) return true;
  if (day === 6) return getISOWeek(date) % 2 === 0;
  return false;
};

// First Forty Days: Monday, Wednesday, Friday only
export const isFortyDaysBookingDay = (date) => {
  const day = date.getDay();
  return day === 1 || day === 3 || day === 5;
};

// Sacred Postpartum Companion: Mondays and Wednesdays only,
// in one of two four-hour windows.
export const COMPANION_SLUG = "postpartum-care-companion";
export const COMPANION_TIME_SLOTS = [
  "10:00 AM – 2:00 PM",
  "12:00 PM – 4:00 PM",
];
export const isCompanionBookingDay = (date) => {
  const day = date.getDay();
  return day === 1 || day === 3;
};

// Mother's Embrace — a closing ceremony held on set weekdays with
// distinct windows per day.
export const EMBRACE_SLUG = "nurtured-closing-ceremony";
export const isEmbraceBookingDay = (date) => {
  const day = date.getDay();
  return day === 2 || day === 3 || day === 5;
};
export const getEmbraceTimeSlots = (date) => {
  if (!date) {
    return [
      "Tue · 11:00 AM – 1:00 PM",
      "Wed · 11:00 AM – 4:00 PM",
      "Fri · 12:00 PM – 2:00 PM",
    ];
  }
  const day = date.getDay();
  if (day === 2) return ["11:00 AM – 1:00 PM"];
  if (day === 3) return ["11:00 AM – 4:00 PM"];
  if (day === 5) return ["12:00 PM – 2:00 PM"];
  return [];
};

// Nourishing Meal Preparation — held Mondays, Tuesdays, Wednesdays
// each week plus one Saturday per month.
export const MEALS_SLUG = "nourishing-meal-preparation";
export const MEALS_TIME_SLOTS = ["11:00 AM – 4:00 PM"];
export const isMealsBookingDay = (date) => {
  const day = date.getDay();
  if (day === 1 || day === 2 || day === 3) return true;
  // First Saturday of the month
  return day === 6 && date.getDate() <= 7;
};

// Belly Binding & Womb Healing — held Mondays, Tuesdays, Wednesdays only.
export const BELLY_SLUG = "belly-binding-womb-healing";
export const BELLY_TIME_SLOTS = ["11:00 AM – 4:00 PM"];
export const isBellyBookingDay = (date) => {
  const day = date.getDay();
  return day === 1 || day === 2 || day === 3;
};

// Planning for the 4th Trimester — a fixed 6-week Sunday cohort.
export const FOURTH_TRIMESTER_SLUG = "planning-for-the-4th-trimester";
export const FOURTH_TRIMESTER_DATES = [
  "2027-02-21",
  "2027-02-28",
  "2027-03-07",
  "2027-03-14",
  "2027-03-21",
  "2027-03-28",
];
export const FOURTH_TRIMESTER_TIME_SLOTS = ["3:00 PM – 5:00 PM"];
export const FOURTH_TRIMESTER_FIRST_DATE = new Date(2027, 1, 21);
export const FOURTH_TRIMESTER_LAST_DATE = new Date(2027, 2, 28);

const toKey = (d) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

export const isFourthTrimesterBookingDay = (date) =>
  FOURTH_TRIMESTER_DATES.includes(toKey(date));
